var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1373 10.3939L3.74999 13.9877C3.93308 14.1707 4.22984 14.1707 4.41292 13.9877L4.6891 13.7115C4.87218 13.5285 4.87218 13.2317 4.6891 13.0486L2.30839 10.6875H19.5312C19.7901 10.6875 20 10.4776 20 10.2187V9.90625C20 9.64738 19.7901 9.43749 19.5312 9.43749H2.30886L4.6891 7.0764C4.87218 6.89335 4.87218 6.59656 4.6891 6.41347L4.41289 6.1373C4.22984 5.95425 3.93304 5.95421 3.74999 6.1373L0.1373 9.73105C-0.0457471 9.9141 -0.0457861 10.2109 0.1373 10.3939Z",
    fill: "#D93A4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceOut);
export default __webpack_public_path__ + "static/media/invoice-out.a6c1fe47d21eedfd9c31fab2d93c9864.svg";
export { ForwardRef as ReactComponent };